import type { ClientSite, Project } from '../types/project'

export const featuredProject: Project = {
  id: 'labs',
  name: 'SolarisPKN-Labs',
  tagline: 'Un proyecto diseñado para contener otros proyectos',
  summary:
    'El sitio de desarrollo oficial del ecosistema SolarisPKN: el lugar donde viven los proyectos, los experimentos, la documentación técnica y lo que todavía no existe. No es un portfolio, es la plataforma sobre la que se apoya todo lo demás.',
  concept:
    'Centralizar. En vez de repartir el trabajo en repos sueltos y capturas de pantalla, Labs lo ordena en un solo lugar con estructura, documentación y despliegue público.',
  status: 'activo',
  languages: ['Astro', 'MDX', 'JavaScript', 'CSS', 'HTML'],
  stack: ['Astro', 'Cloudflare Pages', 'GitHub Actions', 'Cloudflare D1', 'Workers'],
  points: [
    'Sitio público bilingüe con diseño responsive y navegación por secciones',
    'Estructura de showcase de proyectos y documentación técnica',
    'Despliegue continuo sobre Cloudflare Pages',
    'Base preparada para blog, arquitectura, cuentas y licenciamiento',
  ],
  repo: 'https://github.com/SolarisPKN/SolarisPKN-Labs',
  site: 'https://labs.solarispkn.com.ar',
  license: 'GPL-3.0',
}

export const projects: Project[] = [
  {
    id: 'control',
    name: 'SolarisPKN-Control',
    tagline: 'Encender una PC sin estar en la misma habitación',
    summary:
      'Sistema de control remoto de encendido basado en ESP32 + Arduino IoT Cloud. Simula el comportamiento real del botón Power SW de la placa madre, sin instalar absolutamente nada en la máquina controlada.',
    concept:
      'Control físico, no software. Al replicar el pulso del botón, el sistema funciona incluso con el equipo colgado, apagado o sin sistema operativo.',
    status: 'estable',
    languages: ['C', 'C++'],
    stack: ['ESP32', 'Arduino IoT Cloud', 'Relé / optoacoplador', 'Wake-on-LAN (v2)'],
    points: [
      'Pulso corto de 500 ms: encendido y apagado normal por sistema operativo',
      'Pulso largo de 15 s: apagado forzado ante bloqueos, independiente del SO',
      'Máquina de estados no bloqueante para el control del relé',
      'Firmware optimizado para operación 24/7 de bajo consumo',
    ],
    metrics: [
      { label: 'Frecuencia CPU', value: '240 → 80 MHz' },
      { label: 'Consumo en reposo', value: '↓ 20–30 %' },
      { label: 'Temperatura', value: '↓ 3–8 °C' },
    ],
    repo: 'https://github.com/SolarisPKN/SolarisPKN-Control',
    license: 'GPL-3.0',
  },
  {
    id: 'stats',
    name: 'SolarisPKN-Stats',
    tagline: 'Métricas crudas, verificables y reutilizables',
    summary:
      'Sistema automatizado que recolecta, guarda y actualiza estadísticas de proyectos alojados en distintas plataformas, dejándolas en JSON plano listo para que las consuma cualquier sitio, dashboard o herramienta.',
    concept:
      'Arquitectura por conectores. Un registry.json central define qué proyecto consulta qué plataforma; agregar un proyecto nuevo no toca el núcleo del sistema.',
    status: 'activo',
    languages: ['JavaScript'],
    stack: ['Cloudflare Workers', 'GitHub Actions', 'REST', 'GraphQL', 'JSON'],
    points: [
      'Conectores independientes para GitHub, Cloudflare y PageSpeed Insights',
      'Worker con scheduler propio por conector para no gastar API de más',
      'GraphQL cuando la plataforma lo permite: cinco métricas, una sola request',
      'Historial versionado por proyecto en stats.json + history/',
    ],
    repo: 'https://github.com/SolarisPKN/SolarisPKN-Stats',
    license: 'GPL-3.0',
  },
  {
    id: 'livetools',
    name: 'SolarisPKN-LiveTools',
    tagline: 'Infraestructura para creadores, no scripts sueltos',
    summary:
      'Solaris Media Production Suite: un toolkit modular para producción audiovisual, streaming en vivo y creación de contenido. Scripts, automatizaciones, integraciones y recursos que trabajan como un mismo ecosistema.',
    concept:
      'La producción de contenido está fragmentada. LiveTools existe para que el creador pelee menos con las herramientas y dedique ese tiempo a crear.',
    status: 'activo',
    languages: ['C#'],
    stack: ['.NET', 'Streamer.bot', 'StreamElements', 'APIs de plataformas'],
    points: [
      'Importación de puntos de lealtad de StreamElements',
      'Sincronización automática hacia la variable %sepoints% de Streamer.bot',
      'Herramienta de migración de saldos a base de datos local',
      'Acción de migración completa + script standalone para integraciones propias',
    ],
    repo: 'https://github.com/SolarisPKN/SolarisPKN-LiveTools',
    license: 'GPL-3.0',
  },
]

export const clientSites: ClientSite[] = [
  {
    name: 'Lubricantes Villars',
    detail: 'Sitio web comercial para un lubricentro local.',
    repo: 'https://github.com/SolarisPKN/Lubricantes-Villars',
  },
  {
    name: "La Cascada de Any's",
    detail: 'Artesanías y sabores. Catálogo y presencia online.',
    repo: 'https://github.com/SolarisPKN/La-Cascada-de-Any-s',
  },
  {
    name: 'Analía Orayen',
    detail: 'Sitio profesional para terapeuta integral.',
    repo: 'https://github.com/SolarisPKN/Analia-Orayen---Terapeuta-Integral',
  },
]
